import React from "react";
import { Box } from "@mui/material";
import { LineChart } from "@mui/x-charts/LineChart";
import moment from "moment-timezone";

/**
 * Acquired Line Chart Component using MUI X Charts
 * Displays acquisition data over time
 * @param {Object} props
 * @param {Array} props.data - Array of line data objects
 * @returns {import("react").ReactElement}
 */
export default function AcquiredLine(props) {
  const { data } = props;

  if (!data || !data[0] || !data[0].data || data[0].data.length === 0) {
    return (
      <Box sx={{ position: "relative" }}>
        <Box sx={{ display: "inline-block", width: 590, height: 300, mb: -2.5 }} />
      </Box>
    );
  }

  const lineData = data[0];
  const dates = lineData.data.map((item) => item.x);
  const values = lineData.data.map((item) => item.y);

  // Create x-axis data as indices
  const xAxisData = dates.map((_, index) => index);

  // Format dates for x-axis labels
  const formattedDates = dates.map((date) => moment.utc(date).format("MMM DD"));

  return (
    <Box sx={{ position: "relative" }}>
      <Box sx={{ display: "inline-block", width: 590, height: 300, mb: -2.5 }}>
        <LineChart
          xAxis={[
            {
              data: xAxisData,
              scaleType: "point",
              valueFormatter: (value) => formattedDates[value] || "",
              tickLabelStyle: {
                fontSize: 11,
              },
            },
          ]}
          yAxis={[
            {
              disableLine: true,
            },
          ]}
          series={[
            {
              data: values,
              label: lineData.name || "Acquired",
              color: lineData.color || "#03a9f4",
              showMark: false,
              curve: "linear",
              valueFormatter: (value) => value?.toLocaleString() || "0",
            },
          ]}
          width={590}
          height={300}
          margin={{ top: 20, right: 20, bottom: 30, left: 50 }}
          hideLegend
        />
      </Box>
    </Box>
  );
}
